/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1WorkoutRequestData
 */
export interface V1WorkoutRequestData {
    /**
     *
     */
    fitnessLevel?: string
    /**
     *
     */
    ageBracket?: string
    /**
     *
     */
    sexAtBirth?: string
    /**
     *
     */
    activityLevel?: string
    /**
     *
     */
    fitnessGoal?: string
    /**
     *
     */
    exerciseHistory?: string
    /**
     *
     */
    daysPerWeek?: string
    /**
     *
     */
    sessionTime?: string
    /**
     *
     */
    bestTimeForWorkout?: string
    /**
     *
     */
    dislikedExercises?: string
    /**
     *
     */
    workoutLocation?: string
    /**
     *
     */
    availableEquipment?: string
    /**
     *
     */
    healthIssues?: string
    /**
     *
     */
    customNotes?: string
    /**
     *
     */
    languages?: Array<string>
}

/**
 * Check if a given object implements the V1WorkoutRequestData interface.
 */
export function instanceOfV1WorkoutRequestData(
    value: object
): value is V1WorkoutRequestData {
    return true
}

export function V1WorkoutRequestDataFromJSON(json: any): V1WorkoutRequestData {
    return V1WorkoutRequestDataFromJSONTyped(json, false)
}

export function V1WorkoutRequestDataFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1WorkoutRequestData {
    if (json == null) {
        return json
    }
    return {
        fitnessLevel:
            json['fitnessLevel'] == null ? undefined : json['fitnessLevel'],
        ageBracket: json['ageBracket'] == null ? undefined : json['ageBracket'],
        sexAtBirth: json['sexAtBirth'] == null ? undefined : json['sexAtBirth'],
        activityLevel:
            json['activityLevel'] == null ? undefined : json['activityLevel'],
        fitnessGoal:
            json['fitnessGoal'] == null ? undefined : json['fitnessGoal'],
        exerciseHistory:
            json['exerciseHistory'] == null
                ? undefined
                : json['exerciseHistory'],
        daysPerWeek:
            json['daysPerWeek'] == null ? undefined : json['daysPerWeek'],
        sessionTime:
            json['sessionTime'] == null ? undefined : json['sessionTime'],
        bestTimeForWorkout:
            json['bestTimeForWorkout'] == null
                ? undefined
                : json['bestTimeForWorkout'],
        dislikedExercises:
            json['dislikedExercises'] == null
                ? undefined
                : json['dislikedExercises'],
        workoutLocation:
            json['workoutLocation'] == null
                ? undefined
                : json['workoutLocation'],
        availableEquipment:
            json['availableEquipment'] == null
                ? undefined
                : json['availableEquipment'],
        healthIssues:
            json['healthIssues'] == null ? undefined : json['healthIssues'],
        customNotes:
            json['customNotes'] == null ? undefined : json['customNotes'],
        languages: json['languages'] == null ? undefined : json['languages']
    }
}

export function V1WorkoutRequestDataToJSON(json: any): V1WorkoutRequestData {
    return V1WorkoutRequestDataToJSONTyped(json, false)
}

export function V1WorkoutRequestDataToJSONTyped(
    value?: V1WorkoutRequestData | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        fitnessLevel: value['fitnessLevel'],
        ageBracket: value['ageBracket'],
        sexAtBirth: value['sexAtBirth'],
        activityLevel: value['activityLevel'],
        fitnessGoal: value['fitnessGoal'],
        exerciseHistory: value['exerciseHistory'],
        daysPerWeek: value['daysPerWeek'],
        sessionTime: value['sessionTime'],
        bestTimeForWorkout: value['bestTimeForWorkout'],
        dislikedExercises: value['dislikedExercises'],
        workoutLocation: value['workoutLocation'],
        availableEquipment: value['availableEquipment'],
        healthIssues: value['healthIssues'],
        customNotes: value['customNotes'],
        languages: value['languages']
    }
}
